import { post } from 'lib/api';

import { useMutation, useQueryClient } from '@tanstack/react-query';

const postLogoutAccount = async () => {
  return await post('auth/logout');
};

export function useLogout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postLogoutAccount,
    onSuccess: () => {      
      queryClient.clear();
    }
  });
}
